import SidebarLayout from "../../../../layouts/SidebarLayout";
import PaidListTable from "./PaidListTable";
import PartialListTable from "./PendingListTable";

export default function PaymentDetails() {
  return (
    <SidebarLayout
      title="Disbursement Details"
      backLink="/admin/salary-disbursement/payments"
    >
      <div className="self-stretch justify-start text-zinc-700 text-xl font-semibold mb-4">
        Paid List
      </div>
      <PaidListTable />

      <div className="self-stretch justify-start text-zinc-700 text-xl font-semibold mb-4 mt-6">
        Partial List
      </div>

      <PartialListTable />
    </SidebarLayout>
  );
}
